var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.clientId)?_c('div',{ref:"googleButton",staticClass:"google-button"}):_c('button',{staticClass:"google-fallback",attrs:{"type":"button","disabled":""}},[_vm._v(" "+_vm._s(_vm.$t('google_signin_unavailable'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }